<template>
  <v-alert
    v-if="isImpersonatingSuco"
    type="warning"
    variant="tonal"
    density="compact"
    :text="bannerText"
    class="mb-4"
  >
    <template #append>
      <v-btn variant="text" size="small" color="warning" @click="exit">
        Reset
      </v-btn>
    </template>
  </v-alert>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import {
  useExitImpersonation,
  useImpersonation
} from '@/composables/impersonation';

const { isImpersonatingSuco, impersonatedSucoName } = useImpersonation();
const exit = useExitImpersonation();

const bannerText = computed(
  () =>
    `You are viewing this depot as the subcontractor "${impersonatedSucoName.value ?? 'Subcontractor'}". The data and navigation reflect what they would see. This is not the actual subcontractor view, so use it with caution.`
);
</script>
